import type { ComponentProps } from 'react'
import fsnNetworkMarkUrl from '@/assets/fsn-network-mark.svg'
import { cn } from '@/lib/utils'

export default function FsnNetworkIcon({
  className = '',
  alt = '',
  ...props
}: ComponentProps<'img'>) {
  return (
    <img
      src={fsnNetworkMarkUrl}
      alt={alt}
      className={cn('shrink-0 scale-[1.42] object-contain', className)}
      {...props}
    />
  )
}
